export const customSlick = () => {
	$(function(){
		function sliderSetting(){
	 
			var width = $(window).width();
	 
			if(width <= 640){
				$('.area-price-box').not('.slick-initialized').slick({
					autoplay: true,       //自動再生
		            autoplaySpeed: 2000,  //自動再生のスピード
		            speed: 800,           //スライドするスピード
		            dots: true,           //スライド下のドット
		            arrows: false,         //左右の矢印
		            infinite: true,       //永久にループさせる
				});

			} else {
				$('.area-price-box.slick-initialized').slick('unslick');

			}

			if(width <= 640){
				$('.calender').not('.slick-initialized').slick({
					autoplay: false,       //自動再生
		            autoplaySpeed: 2000,  //自動再生のスピード
		            speed: 800,           //スライドするスピード
		            dots: false,           //スライド下のドット
		            // arrows: true,         //左右の矢印
		            infinite: true,       //永久にループさせる
					slidesToShow: 1,
					prevArrow: '<button class="slide-arrow prev-arrow"></button>',
					nextArrow: '<button class="slide-arrow next-arrow"></button>'
				});

			} else {
				$('.calender.slick-initialized').slick('unslick');

			}
			if (width > 640) {
				$('.voice-items-container').not('.slick-initialized').slick({
				  autoplay: false,
				  //自動再生
				  autoplaySpeed: 2000,
				  //自動再生のスピード
				  speed: 800,
				  //スライドするスピード
				  dots: false,
				  //スライド下のドット
				  // arrows: true,         //左右の矢印
				  infinite: true,
				  //永久にループさせる
				  slidesToShow: 1,
				  centerMode: true,
				  variableWidth: true,
				  
				  prevArrow: '<button class="slide-arrow prev-arrow"></button>',
				  nextArrow: '<button class="slide-arrow next-arrow"></button>'
				});
			  } else {
				$('.voice-items-container.slick-initialized').slick('unslick');
			  }
		}
	 
		sliderSetting();
	 
		$(window).resize( function() {
			sliderSetting();
		});
	});
};